import { formatDate, formatEventTypeLabel } from 'tools/helper'

const getIconSvgString = (iconName: string) => {
  const mapIconSvg = new Map<string, string>([
    [
      'Speed',
      `
<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#FF0000">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M20.38 8.57l-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44zm-9.79 6.84a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83z"/>

</svg>  `,
    ],
    [
      'WarningAmber',
      `
<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="48px" viewBox="0 0 24 24" width="48px" fill="#FF0000">
  <g><rect fill="none" height="24" width="24"/></g>
  <g><g><g><path d="M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2z"/><polygon points="13,16 11,16 11,18 13,18"/><polygon points="13,10 11,10 11,15 13,15"/></g></g></g>
</svg>
  `,
    ],
    [
      'TurnLeft',
      `
<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="48px" viewBox="0 0 20 20" width="48px" fill="#FF0000">
  <g><rect fill="none" height="20" width="20"/></g>
  <g><path d="M12,16h1.5V9c0-0.83-0.67-1.5-1.5-1.5l-6.13,0l1.19-1.19L6,5.25l-3,3l3,3l1.06-1.06L5.87,9L12,9V16z"/></g>
</svg>
  `,
    ],
    [
      'ArrowUpward',
      `
<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#FF0000">
  <path d="M0 0h24v24H0V0z" fill="none"/>
  <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/>
</svg>
  `,
    ],
    [
      'DirectionsCar',
      `
<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#FF0000">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
</svg>
  `,
    ],
    [
      'RemoveRoad',
      `
<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="48px" viewBox="0 0 20 20" width="48px" fill="#FF0000">
  <g><rect fill="none" height="20" width="20"/></g>
  <g><g><rect height="12" width="1.5" x="4" y="4"/><rect height="6.5" width="1.5" x="14.5" y="4"/><rect height="3" width="1.5" x="9.25" y="8.5"/><rect height="3" width="1.5" x="9.25" y="4"/><rect height="3" width="1.5" x="9.25" y="13"/><polygon points="18,13.56 16.94,12.5 15.25,14.19 13.56,12.5 12.5,13.56 14.19,15.25 12.5,16.94 13.56,18 15.25,16.31 16.94,18 18,16.94 16.31,15.25"/></g></g>
</svg>
  `,
    ],
    [
      'ReportProblem',
      `
<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#FF0000">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
</svg>
  `,
    ],
    [
      'SyncProblem',
      `
<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#FF0000">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"/>
</svg>
  `,
    ],
    [
      'Traffic',
      `
<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#FF0000">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"/> 
</svg>
  `,
    ],
    [
      'WrongLocation',
      `
<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="48px" viewBox="0 0 20 20" width="48px" fill="#FF0000">
  <g><rect fill="none" height="20" width="20"/></g>
  <g><g><path d="M12,8V4.37C11.37,4.13,10.69,4,10,4C7.06,4,4.4,6.25,4.4,9.74c0,2.32,1.87,5.08,5.6,8.26c3.73-3.18,5.6-5.94,5.6-8.26 c0-0.62-0.09-1.2-0.24-1.74H12z M10,11c-0.83,0-1.5-0.67-1.5-1.5S9.17,8,10,8s1.5,0.67,1.5,1.5S10.83,11,10,11z"/><polygon points="17.47,3.23 16.77,2.53 15,4.29 13.23,2.53 12.53,3.23 14.29,5 12.53,6.77 13.23,7.47 15,5.71 16.77,7.47 17.47,6.77 15.71,5"/></g></g>
</svg>
  `,
    ],
    [
      'CarCrash',
      `
<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height="48px" viewBox="0 0 20 20" width="48px" fill="#FF0000">
  <g><rect fill="none" height="20" width="20"/></g>
  <g><g><path d="M19,5c0,2.21-1.79,4-4,4s-4-1.79-4-4s1.79-4,4-4S19,2.79,19,5z M15.5,6h-1v1h1V6z M15.5,3h-1v2h1V3z M15,10.5 c-0.32,0-0.64-0.03-0.94-0.08c0.27,0.18,0.44,0.48,0.44,0.83c0,0.55-0.45,1-1,1c-0.55,0-1-0.45-1-1c0-0.51,0.39-0.93,0.88-0.99 C12.14,9.87,11.09,9.06,10.39,8H5.02l1-2.5h3.51C9.47,4.99,9.51,4.39,9.59,4H6.02C5.4,4,4.85,4.37,4.62,4.94L3,9l0,6.5 C3,15.78,3.22,16,3.5,16h1C4.78,16,5,15.78,5,15.5v-1h10v1c0,0.28,0.22,0.5,0.5,0.5h1c0.28,0,0.5-0.22,0.5-0.5v-5.38 C16.38,10.37,15.71,10.5,15,10.5z M6.5,12.25c-0.55,0-1-0.45-1-1s0.45-1,1-1c0.55,0,1,0.45,1,1S7.05,12.25,6.5,12.25z"/></g></g>
</svg>
  `,
    ],
  ])
  return mapIconSvg.get(iconName) ?? ''
}

const getRouteIconSvgString = (iconName: string) => {
  const mapIconSvg = new Map<string, string>([
    [
      'start',
      `
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#007BFF">
                <rect x="0" y="0" width="24" height="24" fill="transparent"/>
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M12 4C9.24 4 7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" opacity=".3"/>
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"/>
                <circle cx="12" cy="9" r="2.5"/>
            </svg>
        `,
    ],
    [
      'end',
      `
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#6A0DAD">
                <rect x="0" y="0" width="24" height="24" fill="transparent"/>
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M12 4C9.24 4 7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" opacity=".3"/>
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"/>
                <circle cx="12" cy="9" r="2.5"/>
            </svg>
        `,
    ],
  ])
  return mapIconSvg.get(iconName) ?? ''
}

const getSpeedColor = (
  speed: number,
  speedLimit: number
): [number, number, number, number] => {
  if (!speed || !speedLimit) {
    return [0, 150, 255, 180] // #0096FF - Blue
  }

  const speedDifference = speed - speedLimit

  if (speedDifference <= 0) {
    return [0, 150, 255, 180] // #0096FF - Blue
  } else if (speedDifference <= 10) {
    return [255, 128, 0, 180] // #FF8000 - Orange
  } else if (speedDifference <= 15) {
    return [255, 0, 0, 180] // #FF0000 - Red
  } else if (speedDifference <= 20) {
    return [162, 0, 237, 180] // #A200ED - Purple
  } else {
    return [31, 0, 31, 180] // #1F001F - Dark purple
  }
}

const getTooltipData = (object: any, layer: any) => {
  if (!object || layer?.id !== 'safety-events-clustered') return null

  if (object.isCluster) {
    return {
      html: `<div style="padding: 12px; background: white; color: #333; border-radius: 8px; font-size: 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; line-height: 1.4;">
      <div style="font-weight: 600; margin-bottom: 4px;">Cluster</div>
      <div>${object.pointCount} safety events</div>
      <div style="font-style: italic; margin-top: 4px; color: #666;">Click to zoom in</div>
    </div>`,
      style: {
        backgroundColor: 'transparent',
        fontSize: '14px',
      },
    }
  } else {
    return {
      html: `<div style="padding: 12px; background: white; color: #333; border-radius: 8px; font-size: 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; line-height: 1.4;">
      <div style="font-weight: 600; margin-bottom: 4px;">${
        formatEventTypeLabel(object.type) || '-'
      }</div>
      <div style="margin-bottom: 4px;">Time: ${
        object.time ? formatDate(object.time) : '-'
      }</div>
      <div>VIN: ${object.vin || '-'}</div>
      <div style="font-style: italic; margin-top: 4px; color: #666;">Click to view route/details</div>
    </div>`,
      style: {
        backgroundColor: 'transparent',
        fontSize: '14px',
      },
    }
  }
}
export {
  getIconSvgString,
  getRouteIconSvgString,
  getSpeedColor,
  getTooltipData,
}
